import { useEffect, useState } from 'react';
import './index.less'
import { getPlainText } from '@/utils';
import { Modal, Empty, Pagination } from 'antd'
import { cancelFavorite } from '@/api/questions';
import { getMyCollectList } from '@/api/user'
import { useNavigate } from 'react-router-dom'
import useThumbsUp from '../../hooks/useThumbsUp';

const MyCollect = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [collectList, setCollectList] = useState([])
  const [pageNumber, setPageNumber] = useState(0)
  const [total, setTotal] = useState(0)
  const navigate = useNavigate();
  const { handleThumbsUp } = useThumbsUp();

  const handleCancelCollect = (id: string, type: 'UGC' | 'FAQ') => {
    modal.confirm({
      title: '提示',
      content: '确认取消收藏吗？',
      okText: '确认',
      cancelText: '取消',
      onOk: async() => {
        try {
          const typeMap = {
            UGC: 'questAndAnswer',
            FAQ: 'faq',
            NOTICE: 'notice',
          };
          const cancelType = typeMap[type];
          const res: any = await cancelFavorite(cancelType as 'questAndAnswer' | 'notice' | 'faq', id);
          if (res.code == 200) {
            window.message?.success('取消成功',2);
            const list = [...collectList];  
            const index = list.findIndex((item: any) => item.sourceId === id);
            list.splice(index, 1)
            setCollectList(list);
            setTotal(total - 1);
          }
        } catch (error) {
          console.log("err", error);
        }
      },
    });
  }

  const getList = async(page: number) => {
    const res = await getMyCollectList({
      pageNumber: page,
      pageSize: 5,
    })
    if (res?.code === 200) {
      setCollectList(res.result.records);
      setTotal(res.result.total);
      setPageNumber(res.result.current);
    }
  }

  const paginationChange = (page: number) => {
    getList(page);
  };

  const viewDetail = (sourceId: string, type: 'UGC' | 'FAQ' | 'NOTICE') => {
    const typeMap = {
      UGC: 'feedback',
      FAQ: 'faq',
      NOTICE: 'notice',
    };
    navigate(`/technicalSupport/${typeMap[type]}Detail/${sourceId}`);
  }
  useEffect(() => {
    getList(1)
  }, [])

  return <div className="my-collect">
    {contextHolder}
    <div className="my-collect-title">我的收藏</div>
    <div className="my-collect-main">
      { 
        collectList.length === 0 ?  <div className='empty-content'>
          <Empty description="暂无收藏" />
        </div> : null
      }
      {
        collectList.map((item: any) => {
          return <div className='collect-item-card' key={item.sourceId}>
            <div title={item.overview || item.title} onClick={() => viewDetail(item.sourceId, item.type)}>{item.overview || item.title}</div>
            <div title={getPlainText(item?.description || item?.content)} onClick={() => viewDetail(item.sourceId, item.type)}>{getPlainText(item?.description || item?.content)}</div>
            <div>
              <span>{item.createTime}</span>
              <div className='operate-box'>
                <span onClick={() => handleThumbsUp(item.type, item.sourceId, item.currentUserIsThumbsUp, setCollectList)}>
                  <img src={item.currentUserIsThumbsUp ? require('@/assets/images/support/avport.png') : require('@/assets/images/support/no-avport.png')} alt="" />
                  {item.thumbsUpCount}
                </span>
                <span>
                  <img src={require('@/assets/images/support/look.png')} alt="" />
                  {item.viewCount}
                </span>
                <span>
                  <img src={require('@/assets/images/icon-more.png')} alt="" />
                  <span className='cancel-collect' onClick={() => handleCancelCollect(item.sourceId, item.type)}>取消收藏</span>
                </span>
              </div>
            </div>
          </div>
        })
      }
      {
        total > collectList.length && <Pagination
          pageSize={5}
          current={pageNumber}
          showSizeChanger={false}
          total={total}
          rootClassName="pagination"
          onChange={paginationChange}
        />
      }
    </div>
  </div>
}

export default MyCollect;